import { UserAddOutlined } from '@ant-design/icons';
import { Button, ConfigProvider, DatePicker, Form } from 'antd';
import dayjs from 'dayjs';
import { UploadMultipleFile } from '@/components/upload-multiple-file';
import { UploadedAttachmentsList } from '@/components/uploaded-attachments-list';
import { cn } from '@/libs/utils';
import { DATE_FORMATS } from '@/utils/formUtils';
import { useEmployeeGeneralDataForm } from '../EmployeeGeneralDataFormContext';

/** Work permit date, attachments and the history button. */
export default function EmployeeDocumentsFields() {
  const {
    dateOfWorkPermissionForeignerKeys,
    dateOfWorkPermissionForeignerState,
    formData,
    isForeignWorkPermitTrackerCompany,
    isProfile,
    readOnly,
    sectionClass,
    setDeletedFileIds,
    setSelectedFiles,
    startDate,
    t,
    toggleDrawer,
    uploadKey,
  } = useEmployeeGeneralDataForm();

  return (
    <>
      {!isProfile && <hr className="my-5" />}

      {isForeignWorkPermitTrackerCompany &&
        dateOfWorkPermissionForeignerState?.visible && (
          <div className={sectionClass('ugovor')}>
            <Form.Item
              name={dateOfWorkPermissionForeignerKeys}
              label={t('dateOfWorkPermissionForeigner', { ns: 'forms' })}
              className="!mb-1 w-full"
            >
              <DatePicker
                minDate={dayjs(startDate, DATE_FORMATS.STANDARD)}
                className="w-full"
                format={DATE_FORMATS.DISPLAY}
                placeholder={t('formValidation.selectDate', { ns: 'forms' })}
                disabled={dateOfWorkPermissionForeignerState?.disabled}
              />
            </Form.Item>

            {!isProfile && <hr className="my-5" />}
          </div>
        )}

      <div className={cn('employee-profile-attachments', sectionClass('dok'))}>
        {!readOnly && (
          <UploadMultipleFile
            key={uploadKey}
            onFilesChange={setSelectedFiles}
          />
        )}

        {!isProfile && <hr className="my-5" />}

        {/* Preview / download stay usable in the read-only profile view. */}
        <ConfigProvider componentDisabled={false}>
          <UploadedAttachmentsList
            readOnly={readOnly}
            attachments={formData?.attachments}
            onMarkFileForDeletion={(fileId) =>
              setDeletedFileIds((prev) => [...prev, fileId])
            }
          />
        </ConfigProvider>
      </div>

      {!isProfile && <hr className="my-5" />}

      {!isProfile && (
        <div className="mb-5">
          <Button
            type="primary"
            icon={<UserAddOutlined />}
            onClick={() => toggleDrawer(true)}
            className="btn-primary w-full"
            size="large"
            style={{
              height: '56px',
              fontSize: '16px',
              fontWeight: '600',
              boxShadow: '0 2px 8px rgba(var(--accentColor), 0.3)',
            }}
          >
            {t('formValidation.additionalPersonalInfo', { ns: 'forms' })}
          </Button>
        </div>
      )}

      {!isProfile && <hr className="my-5" />}
    </>
  );
}
